<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-blue">
      <a class="navbar-brand" href="#">Sahana</a>
      <div class="navbar-nav mr-auto non-collapse-buttons">
        <div class="nav-item">
          <router-link class="nav-link" :to="{name: 'patientAndTestCountOverview'}">
            <font-awesome-icon
              class="icon"
              title="Results pending patient and test count"
              icon="list-ol"
            />
          </router-link>
        </div>

        <div class="nav-item">
          <router-link class="nav-link" :to="{name: 'patientListOverview'}">
            <font-awesome-icon class="icon" title="Results pending patient list" icon="procedures" />
          </router-link>
        </div>

        <div class="nav-item">
          <router-link class="nav-link" to="/register-patient">
            <font-awesome-icon class="icon" title="Register patient" icon="id-card" />
          </router-link>
        </div>
      </div>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <form
              @submit="searchPatient"
              class="form-inline vld-parent"
              id="search-patient-form"
              ref="patientIdElement"
            >
              <input
                type="text"
                class="form-control form-control-sm"
                id="patient-id"
                v-model="patientId"
                placeholder="Patient ID"
                required
              />
            </form>
          </li>
        </ul>

        <div class="my-2 my-lg-0">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item" v-if="showAnalytics">
              <!-- <router-link class="nav-link" to="/analytic"> -->
              <!-- <a class="nav-link" href="https://sahana-om.matrix.com/grafana" target="_blank"> -->
              <a class="nav-link" href="/grafana" target="_blank">
                <font-awesome-icon class="icon" title="Analytics" icon="chart-bar" />
              </a>
              <!-- </router-link> -->
            </li>

            <li class="nav-item">
              <div class="nav-link">
                <LiveDateTime class="date-time" />
              </div>
            </li>

            <li class="nav-item">
              <div class="nav-link">
                <font-awesome-icon class="icon" title="Logged in user" icon="id-badge" />
                &nbsp;&nbsp;{{this.$store.getters.username}}
              </div>
            </li>

            <li class="nav-item">
              <div class="nav-link">
                <font-awesome-icon
                  class="icon logout-icon"
                  title="Logout"
                  icon="sign-out-alt"
                  v-on:click="logout"
                />
              </div>
            </li>

            <!-- <li class="nav-item dropdown">
              <a
                class="nav-link"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></a>
              <div
                class="dropdown-menu dropdown-menu-right bg-blue"
                aria-labelledby="navbarDropdown"
              >
                <span class="dropdown-item" v-on:click="logout">Logout</span>
              </div>
            </li>-->
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import LiveDateTime from "@/components/LiveDateTime.vue";
import Utils from "@/utils.js";
import { LOGOUT_ACTION } from "@/store-constants.js";
import axios from "axios";
import { EventBus } from "@/global-event-bus.js";
import {
  EVENT_SEARCHING_PATIENT_STATUS,
  PARAM_SEARCHING
} from "@/event-constants.js";

import { READ_PERMISSION, ANALYTICS_MODULE } from "@/permission-constants.js";

import { evaluatePermission } from "@/permission-evaluator.js";

export default {
  name: "Navigation",
  data() {
    return {
      patientId: null,
      isSearchingPatient: false,
      searchPatientLoader: null
    };
  },

  components: {
    LiveDateTime
  },

  created() {
    EventBus.$on(
      EVENT_SEARCHING_PATIENT_STATUS,
      this.updateSearchingPatientStatus
    );
  },

  beforeDestroy() {
    EventBus.$off(
      EVENT_SEARCHING_PATIENT_STATUS,
      this.updateSearchingPatientStatus
    );
  },

  methods: {
    logout() {
      let loading = this.$loading.show({
        // container: this.$refs.rootElement
      });

      axios
        .get(Utils.getURL("/logout"))
        .then(() => {
          loading.hide();
          this.$store.dispatch(LOGOUT_ACTION);
          this.$router.push("/");
        })
        .catch(error => {
          loading.hide();
          Utils.notifyError(error);
        });
    },

    updateSearchingPatientStatus(status) {
      var isSearching = status.PARAM_SEARCHING;
      this.isSearchingPatient = isSearching;
    },

    searchPatient(e) {
      // if(this.$route.query.patientId == this.patientId){
      //   e.preventDefault();
      //   return;
      // }
      e.preventDefault();

      this.$router.push({
        name: "test-result",
        query: {
          patientId: this.patientId.trim()
        }
      });

      EventBus.$emit(EVENT_SEARCHING_PATIENT_STATUS, { PARAM_SEARCHING: true });
    }
  },

  computed: {
    showAnalytics: function() {
      let userroles = this.$store.getters.userroles;
      if (userroles == undefined) {
        return false;
      }
      return evaluatePermission(userroles, READ_PERMISSION, ANALYTICS_MODULE);
    }
  },

  watch: {
    isSearchingPatient: function(newValue, oldValue) {
      if (this.isSearchingPatient == true) {
        // if(this.searchPatientLoader == null){
        this.searchPatientLoader = this.$loading.show({
          container: this.$refs.patientIdElement
        });
        // } else {
        //   this.searchPatientLoader.show({
        //     container: this.$refs.patientIdElement
        //   });
        // }
      } else {
        if (this.searchPatientLoader != null) {
          this.searchPatientLoader.hide();
        }
      }
    },

    "$route.query.patientId": function(newValue, oldValue) {
      this.patientId = newValue;
    }
  }
};
</script>

<style scoped>
.icon {
  font-size: large;
  margin-left: 20px;
}

.vld-parent,
.date-time {
  margin-left: 20px;
}

.non-collapse-buttons {
  flex-direction: row;
}

.navbar-brand {
  color: white;
}

.icon:hover {
  color: orange;
  opacity: 1;
}

.logout-icon {
  color: orangered;
}

.navbar-dark .navbar-nav .nav-link {
  color: white;
  opacity: 0.75;
}

</style>
